import {Heading, ModalBody, ModalCloseButton, ModalContent, ModalHeader, VStack} from '@chakra-ui/react';
import {useCardPayment} from 'components/providers/CardPaymentProvider';
import {IModalProps, Modal} from 'components/shared';
import {useTranslation} from 'hooks';
import {FC} from 'react';
import {modalCloseButtonStyles} from 'theme';

import {CardItem} from './CardItem';
import {EmptyCards} from './EmptyCards';

interface Props extends IModalProps {
  isOpen: boolean;
}

export const CardsModal: FC<Props> = ({onClose, isOpen}) => {
  const {t} = useTranslation();
  const {cardQuery, selectedCard, onRemoveCard, onChangeCard} = useCardPayment();
  const {data: cards, isLoading} = cardQuery;

  const finalCards = cards?.length
    ? [
        ...cards,
        {
          id: 0, //new card
          masked_card_number: t('payWithNewCard'),
          is_main: false,
        },
      ]
    : [];

  if (!isOpen) return null;
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent maxW="700px" maxH={['85vh', '90vh']} mx={['15px', 0]}>
        <ModalHeader p="30px" display="flex" alignItems="center" justifyContent="space-between">
          <Heading fontSize="24px" fontWeight="bold">
            {t('SELECT_CARD')}
          </Heading>
          <ModalCloseButton onClick={onClose} position="static" sx={modalCloseButtonStyles} />
        </ModalHeader>
        <ModalBody px="30px" pb="30px" pt="0" overflowY="scroll">
          <VStack spacing="20px" alignItems="stretch" mb="30px">
            {(cards && !cards?.length) || isLoading ? (
              <EmptyCards isLoading={isLoading} />
            ) : (
              finalCards?.map((card) => {
                return (
                  <CardItem
                    key={card.id}
                    card={card}
                    onRemove={() => onRemoveCard(card.id)}
                    onSelect={() => onChangeCard(card)}
                    isSelected={card.id === selectedCard?.id}
                    t={t}
                    withBorder
                  />
                );
              })
            )}
          </VStack>
        </ModalBody>
        {/* <ModalFooter p="0 30px 30px">
          <Button variant="primary" ml="auto" w="full" onClick={onAddNewCard}>
            + {t('addNewCard')}
          </Button>
        </ModalFooter> */}
      </ModalContent>
    </Modal>
  );
};
